module.exports = "<p>\r\n  admin-layout works!\r\n</p>\r\n<router-outlet></router-outlet>\r\n"